import { FC } from 'react';
import styles from './ContactUs.module.less';
import banner from '../assets/banner2.png';
import { Breadcrumb } from 'antd';
import { useNavigate } from 'react-router-dom';
import phone from '../assets/phone.svg';
import location from '../assets/location02.svg';
import mail from '../assets/mail.svg';

const Index: FC = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.body}>
            <div style={{ height: '280px' }}>
                <img src={banner} alt="" />
            </div>
            <div className={styles.fix}>
                <div style={{ width: '1200px', position: 'relative' }}>
                    <div className={styles.banner}>
                        <div className={styles.title}>联系我们</div>
                    </div>
                    <div className={styles.breadcrumb}>
                        <Breadcrumb>
                            <Breadcrumb.Item className={styles.bread} onClick={() => navigate('/')}>
                                首页
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.bread}>联系我们</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.left}>
                    <div className={styles['left-title']}>北京航空航天大学资产与实验室管理处</div>
                    <div className={styles['icon-group']}>
                        <div className={styles.icon}>
                            <div className={styles.iconimg}>
                                <img src={phone} alt="" />
                            </div>
                            <h2>电话</h2>
                            <div className={styles.text}>赵浩 15011352638</div>
                        </div>
                        <div className={styles.icon}>
                            <div className={styles.iconimg}>
                                <img src={location} alt="" />
                            </div>
                            <h2>地址</h2>
                            <div className={styles.text}>北京市海淀区学院路37号</div>
                        </div>
                        <div className={styles.icon}>
                            <div className={styles.iconimg}>
                                <img src={mail} alt="" />
                            </div>
                            <h2>邮箱</h2>
                            <div className={styles.text}>zhaohao@buaa.edu.cn</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
